import React, { Component } from 'react';

class SwitchButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOn: this.props.isOn ? this.props.isOn : false
        };
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        this.setState(({ isOn: !this.state.isOn }), () => {
            if (this.props.onChange) {
                this.props.onChange(this.props.id,this.state.isOn)
            }
        });
    }

    render() {
        return (
            <div className="ios-switch">
                <input style={{ display: "none" }} type="checkbox" id={"switch" + this.props.id} disabled={this.props.disabled??false} className="ios-switch-checkbox" checked={this.state.isOn} onChange={this.handleToggle} />
                <label htmlFor={"switch" + this.props.id} className="ios-switch-label">
                    <div className="ios-switch-inner" style={this.props.color ? { backgroundColor: this.props.color } : {}} />
                    <div className="ios-switch-switch" />
                </label>
            </div>
        );
    }
}

export default SwitchButton;
